"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _brandedAppsMetadata = require("src/branded-apps-metadata");
var _constants = require("libs/utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var PROVIDERS = [{
  id: 'sso_google',
  type: 'google',
  name: 'Google'
}, {
  id: 'sso_oauth2',
  type: 'oauth2',
  name: 'OAuth2'
}, {
  id: 'saml',
  type: 'saml',
  name: 'SAML'
}, {
  id: 'openidconnect',
  type: 'openidconnect',
  name: 'OpenID Connect'
}];
var PROVIDERS_FORMS = {
  google: _.clone(_brandedAppsMetadata.FORMS.sso.sso_google),
  oauth2: _.clone(_brandedAppsMetadata.FORMS.sso.sso_oauth2),
  saml: _.clone(_brandedAppsMetadata.FORMS.sso.saml),
  openidconnect: _.clone(_brandedAppsMetadata.FORMS.sso.openidconnect)
};
var PROVIDERS_EXTRAS = {
  saml: {
    urlConfigurable: true,
    fileConfigurable: true,
    metadataUrl: _constants.APP_BRANDING_SSO_SAML_METADATA_ENDPOINT,
    configUrl: _constants.APP_BRANDING_SSO_SAML_CONFIG_ENDPOINT
  },
  openidconnect: {
    urlConfigurable: true,
    configUrl: _constants.APP_BRANDING_SSO_OPEN_ID_DISCOVERY_ENDPOINT
  }
};
module.exports = /* @ngInject */["modalService", "userService", "$http", function (modalService, userService, $http) {
  return {
    restrict: 'E',
    scope: {
      branding: '='
    },
    templateUrl: '/static/partials/apps/components/sso-editor.html',
    link: function link(scope) {
      scope.forms = PROVIDERS_FORMS;
      scope.extras = PROVIDERS_EXTRAS;
      var initForms = function initForms() {
        var ssoConfig = scope.branding.sso_config || {};
        if (!ssoConfig) {
          return;
        }
        for (var _i = 0, _Object$keys = Object.keys(ssoConfig); _i < _Object$keys.length; _i++) {
          var configKey = _Object$keys[_i];
          var config = scope.branding.sso_config[configKey];
          if (!config.auto_create_user) {
            config.auto_create_user = {};
          }
          decorateConfig(config, configKey);
        }
      };
      var countConfigOfType = function countConfigOfType(type) {
        var ssoConfig = scope.branding.sso_config;
        var occurrences = 0;
        for (var _i2 = 0, _Object$keys2 = Object.keys(ssoConfig); _i2 < _Object$keys2.length; _i2++) {
          var configKey = _Object$keys2[_i2];
          var config = scope.branding.sso_config[configKey];
          if (config.type === type) {
            occurrences++;
          }
        }
        return occurrences + 1;
      };
      var decorateConfig = function decorateConfig(config, ssoKey) {
        var provider = PROVIDERS.find(function (_ref) {
          var type = _ref.type;
          return type === config.type;
        });
        var conf = config.conf || _.clone(_brandedAppsMetadata.SSO_CONFIG[provider.id].conf);
        var uid = countConfigOfType(provider.type);
        var id = ssoKey || "".concat(config.type, "-").concat(uid);
        if (config.type === 'openidconnect') {
          conf = Object.assign(conf, normalizeOpenIDForm(ssoKey, conf));
        }
        conf.label = conf.label || "".concat(provider.name, " ").concat(uid);
        conf.callbackUrl = conf.callbackUrl || _constants.APP_BRANDING_SSO_CALLBACK.replace('{{branding}}', scope.branding.fp_ext_id).replace('{{id}}', id);
        //  callbackURL is for OAuth, callbackUrl for SAML
        conf.callbackURL = conf.callbackUrl;
        config.auto_create_user = config.auto_create_user || {};

        // SAML default values
        if (provider.type === 'saml' && !conf.issuer) {
          conf.issuer = _constants.APP_BRANDING_SSO_SAML_DEFAULT_ISSUER.replace('{{branding}}', scope.branding.fp_ext_id).replace('{{id}}', id);
        }
        config.provider = provider;
        config.conf = conf;
        config.type = provider.type;
        return id;
      };
      var normalizeOpenIDForm = function normalizeOpenIDForm(id, conf) {
        var model = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PROVIDERS_FORMS['openidconnect'];
        var form = model;
        var keys = [];
        for (var _i3 = 0, _Object$keys3 = Object.keys(form); _i3 < _Object$keys3.length; _i3++) {
          var key = _Object$keys3[_i3];
          if (form[key].kind === 'list') {
            keys.push(key);
          }
        }
        for (var _i4 = 0, _keys = keys; _i4 < _keys.length; _i4++) {
          var secondLevelKey = _keys[_i4];
          if (!_.isArray(conf[secondLevelKey])) {
            var fields = [];
            for (var _i5 = 0, _Object$keys4 = Object.keys(conf[secondLevelKey] || {}); _i5 < _Object$keys4.length; _i5++) {
              var field = _Object$keys4[_i5];
              fields.push({
                key: field,
                value: conf[secondLevelKey][field]
              });
            }
            conf[secondLevelKey] = fields;
          }
        }
        return conf;
      };
      var uploadXml = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config, xml, id) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", postConfiguration(config, {
                  xml: xml
                }, id));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function uploadXml(_x, _x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }();
      var postConfiguration = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(config, params, id) {
          var providerExtras, branding, url, _yield$$http$post, data;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
                branding = scope.branding;
                url = providerExtras.configUrl.replace('{{branding}}', branding.fp_ext_id).replace('{{id}}', id);
                _context2.next = 5;
                return $http.post(url, params);
              case 5:
                _yield$$http$post = _context2.sent;
                data = _yield$$http$post.data;
                setConfig(config, data, id);
              case 8:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function postConfiguration(_x4, _x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }();
      var getConfiguration = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(config, params, id) {
          var providerExtras, branding, url, _yield$$http$get, data;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
                branding = scope.branding;
                url = providerExtras.configUrl.replace('{{branding}}', branding.fp_ext_id).replace('{{id}}', id);
                _context3.next = 5;
                return $http.get(url, params);
              case 5:
                _yield$$http$get = _context3.sent;
                data = _yield$$http$get.data;
                setConfig(config, data, id);
              case 8:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function getConfiguration(_x7, _x8, _x9) {
          return _ref4.apply(this, arguments);
        };
      }();
      var setConfig = function setConfig(config, data, id) {
        try {
          if (data) {
            if (config.type === 'openidconnect') {
              Object.assign(config.conf, normalizeOpenIDForm(id, data.conf || data));
            } else {
              // temp fix (backend fix to come later): remove issuer from config
              // as there is already a default value
              delete data.issuer;
              Object.assign(config.conf, data);
            }
          }
        } catch (error) {
          console.error('Couldn\'t load configuration because the document is malformed');
        }
      };
      scope.$watch('branding.sso_config', initForms);
      scope.isSuperAdmin = userService.matchesRoles({
        globalRole: 'superadmin'
      });
      scope.addSSOConfiguration = function () {
        return modalService.openModalWithForm({
          title: 'Add SSO provider',
          fields: _brandedAppsMetadata.FORMS.addSSOConfiguration,
          saveLabel: 'Add',
          formCanBeSaved: function formCanBeSaved(model) {
            return model.type;
          }
        }).then(function (model) {
          if (typeof scope.branding.sso_config === 'undefined') {
            scope.branding.sso_config = {};
          }
          var config = {
            type: model.type
          };
          var id = decorateConfig(config);
          scope.branding.sso_config[id] = config;
        });
      };
      scope.getCallbackUrl = function (config) {
        // case openIdConnect
        var params = (0, _lodash.get)(config, 'conf.params');
        if ((0, _lodash.isArray)(params)) {
          var redirectUriParam = params.find(function (param) {
            return param.key === 'redirect_url';
          });
          if (redirectUriParam) {
            return redirectUriParam.value;
          }
        }
        return (0, _lodash.get)(config, 'conf.callbackUrl');
      };
      scope.toggleDebug = function (config, id) {
        var debug = scope.branding.sso_config[id].debug;
        if (!debug) {
          var millis = (0, _momentTimezone.default)().add(10, 'day').valueOf();
          debug = Math.round(millis / 1000);
        } else {
          debug = false;
        }
        scope.branding.sso_config[id].debug = debug;
        initForms();
      };
      scope.deleteConfig = function (config, id) {
        if (!window.confirm('Do you want to remove this SSO configuration?')) {
          return;
        }
        delete scope.branding.sso_config[id];
      };
      scope.loadMetadata = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(config, id) {
          var providerEndpoints, branding, url, _yield$$http$get2, data;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                providerEndpoints = PROVIDERS_EXTRAS[config.provider.id];
                if (providerEndpoints) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return");
              case 3:
                branding = scope.branding;
                url = providerEndpoints.metadataUrl.replace('{{branding}}', branding.fp_ext_id).replace('{{id}}', id);
                _context4.next = 7;
                return $http.get(url);
              case 7:
                _yield$$http$get2 = _context4.sent;
                data = _yield$$http$get2.data;
                modalService.openModal({
                  template: "\n                            <div class=\"modal-header\">\n                                <h2>".concat(config.provider.name, " metadata</h2>\n                            </div>\n                            <div class=\"modal-body\">\n                                <textarea readonly rows=\"40\">").concat(data, "</textarea>\n                            </div>\n                            <div class=\"modal-footer\">\n                                <button class=\"btn btn-primary\" ng-click=\"$$modal.reject()\">Close</button>\n                            </div>")
                });
              case 10:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x10, _x11) {
          return _ref5.apply(this, arguments);
        };
      }();
      scope.loadDebugInfo = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(config, id) {
          var provider, url, doc, debugLog;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                provider = config.name || id;
                url = _constants.APP_BRANDING_SSO_DEBUG_ENDPOINT.replace('{{branding}}', scope.branding._id);
                _context5.prev = 2;
                _context5.next = 5;
                return $http.get(url);
              case 5:
                doc = _context5.sent;
                _context5.next = 10;
                break;
              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
              case 10:
                debugLog = !doc || !doc.data ? 'No debug document registered yet.' : JSON.stringify(doc.data, null, 2);
                modalService.openModal({
                  template: "\n                            <div class=\"modal-header\">\n                                <h2>Debug response from ".concat(provider, "</h2>\n                            </div>\n                            <div class=\"modal-body\">\n                                <pre>").concat(debugLog, "</pre>\n                            </div>\n                            <div class=\"modal-footer\">\n                                <button class=\"btn btn-primary\" ng-click=\"$$modal.reject()\">Close</button>\n                            </div>")
                });
              case 12:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[2, 8]]);
        }));
        return function (_x12, _x13) {
          return _ref6.apply(this, arguments);
        };
      }();
      scope.loadConfigurationFromFile = function (files, config, id) {
        var providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
        if (!providerExtras.configUrl) return;
        if (!files || !files.length) return;
        var file = files[0];
        var reader = new FileReader();
        reader.readAsText(file, 'UTF-8');
        reader.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return uploadXml(config, this.result, id);
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
      };
      scope.loadConfigurationFromUrl = function (config, id) {
        var providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
        if (!providerExtras.configUrl) return;
        if (!config.file) return;
        getConfiguration(config, {
          params: {
            url: config.file
          }
        }, id);
      };
      scope.openUserAutoCreate = function (config) {
        var savedConfig = angular.fromJson(angular.toJson(config.auto_create_user || {}));
        var dynEids = (0, _lodash.get)(config, 'auto_create_user.dynamic_eids');
        if (_.isObject(dynEids)) {
          // This happens when you edit the form a second time
          var unnormalizedDynEids = [];
          for (var _i6 = 0, _Object$keys5 = Object.keys(dynEids); _i6 < _Object$keys5.length; _i6++) {
            var eid = _Object$keys5[_i6];
            unnormalizedDynEids.push({
              eid: eid,
              conditions: dynEids[eid]
            });
          }
          config.auto_create_user.dynamic_eids = unnormalizedDynEids;
        }
        var fields = (0, _lodash.get)(config, 'auto_create_user.profile_fields.mapping');
        if (!_.isArray(fields)) {
          // This happens when you edit the form a second time
          var unnormalizedMapping = [];
          if (fields) {
            for (var _i7 = 0, _Object$keys6 = Object.keys(fields); _i7 < _Object$keys6.length; _i7++) {
              var fieldName = _Object$keys6[_i7];
              unnormalizedMapping.push({
                key: fieldName,
                value: fields[fieldName]
              });
            }
          }
          if (!config.auto_create_user.profile_fields) {
            config.auto_create_user.profile_fields = {};
          }
          config.auto_create_user.profile_fields.mapping = unnormalizedMapping;
          fields = unnormalizedMapping;
        }
        var fieldKeys = fields.map(function (field) {
          return field.key;
        });
        modalService.openModal({
          title: 'Auto Create User',
          fields: _.clone(_brandedAppsMetadata.FORMS.sso.auto_create_user),
          saveLabel: 'Save',
          model: config.auto_create_user,
          templateUrl: '/static/partials/apps/auto-create-user-form.html'
        }).then(function (model) {
          var dynEids = model.dynamic_eids;
          var normalizedDynEids = {};
          if (dynEids) {
            var _iterator = _createForOfIteratorHelper(dynEids),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _config = _step.value;
                normalizedDynEids[_config.eid] = _config.conditions;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            model.dynamic_eids = normalizedDynEids;
          }
          var mapping = (0, _lodash.get)(model, 'profile_fields.mapping');
          var normalizedMapping = {};
          if (mapping) {
            var keys = [];
            var _iterator2 = _createForOfIteratorHelper(mapping),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var map = _step2.value;
                normalizedMapping[map.key] = map.value;
                keys.push(map.key);
              }

              // mark previously mapped fields as deleted
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            var _iterator3 = _createForOfIteratorHelper(fieldKeys),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var key = _step3.value;
                if (!keys.includes(key)) {
                  normalizedMapping[key] = {
                    _to_prune: true
                  };
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            model.profile_fields.mapping = normalizedMapping;
          }
          console.info('AutoCreate model', model);
        }).catch(function () {
          return config.auto_create_user = savedConfig;
        });
      };
    }
  };
}];